import type { SVGProps } from 'react';

const CrossErrorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="14" height="14" rx="3" fill="#FF3B30" />
    <path
      d="M9.5153 8.98462C9.58575 9.05507 9.62532 9.15062 9.62532 9.25025C9.62532 9.34987 9.58575 9.44542 9.5153 9.51587C9.44485 9.58632 9.3493 9.6259 9.24967 9.6259C9.15004 9.6259 9.0545 9.58632 8.98405 9.51587L6.99999 7.53118L5.0153 9.51525C4.94485 9.58569 4.8493 9.62527 4.74967 9.62527C4.65005 9.62527 4.5545 9.58569 4.48405 9.51525C4.4136 9.4448 4.37402 9.34925 4.37402 9.24962C4.37402 9.14999 4.4136 9.05444 4.48405 8.984L6.46874 6.99993L4.48467 5.01525C4.41423 4.9448 4.37465 4.84925 4.37465 4.74962C4.37465 4.64999 4.41423 4.55444 4.48467 4.484C4.55512 4.41355 4.65067 4.37397 4.7503 4.37397C4.84993 4.37397 4.94548 4.41355 5.01592 4.484L6.99999 6.46868L8.98467 4.48368C9.05512 4.41323 9.15067 4.37366 9.2503 4.37366C9.34993 4.37366 9.44548 4.41323 9.51592 4.48368C9.58637 4.55413 9.62595 4.64968 9.62595 4.74931C9.62595 4.84894 9.58637 4.94448 9.51592 5.01493L7.53124 6.99993L9.5153 8.98462Z"
      fill="white"
    />
  </svg>
);
export default CrossErrorIcon;
